@if (isDesktop) {
  <div class="membership-page">
    <div class="tab">
      @for (item of compData?.container?.containers; track item) {
        <button
          class="tab-links"
          [class.active]="selectedTab?.key === item?.key"
          (click)="onTab(item)">
          {{ item?.displayName | titlecase }}
        </button>
      }
    </div>
  </div>
}
@if (!isDesktop) {
  <div class="membership-page">
    <app-b2b-drag-scroll [config]="swiperConfig">
      @for (item of compData?.container?.containers; track item) {
        <app-b2b-drag-scroll-item [config]="swiperConfig">
          <div class="mob-tab">
            <button
              class="tab-links"
              [class.active]="selectedTab?.key === item?.key"
              (click)="onTab(item)">
              {{ item?.displayName | titlecase }}
            </button>
          </div>
        </app-b2b-drag-scroll-item>
      }
    </app-b2b-drag-scroll>
    <!--<div class="tab">
    <button
      *ngFor="let item of compData?.container?.containers;"
      class="tab-links"
      [class.active]="selectedTab?.key === item?.key"
      (click)="onTab(item)">
      {{ item?.displayName | titlecase }}
    </button>
  </div>-->
</div>
}
